import { useEffect } from "react";
import { useOnlineStatus } from "./useOnlineStatus";
import { useOfflineDownloadStore } from "./offlineDownloadStore";
import type { Prefix } from "./offlineDownload";

const PREFIXES: Prefix[] = ["LS", "YO", "WF", "HG"];

export function useDownloadBootstrap() {
  const online = useOnlineStatus();
  const ensureJob = useOfflineDownloadStore((s) => s.ensureJob);
  const resumeQueuedDownloads = useOfflineDownloadStore((s) => s.resumeQueuedDownloads);
  const pauseAllDownloads = useOfflineDownloadStore((s) => s.pauseAllDownloads);

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      await Promise.all(PREFIXES.map((p) => ensureJob(p)));
      if (cancelled) return;
      if (online) {
        await resumeQueuedDownloads();
      } else {
        pauseAllDownloads("offline");
      }
    };

    void bootstrap();
    return () => {
      cancelled = true;
    };
  }, [ensureJob, resumeQueuedDownloads, online]);
}
